import { FILL_STYLE, LABEL_STYLE, OUTLINE_STYLE, SYMBOL_STYLE } from "./GeoshapeStyle.js";
import Util from "./Util.js";
export default class GeoshapeAdapter {
  /**
   * This will walk the shapes data and invoke the callback for each item
   * @param {object} shapes the object that contains the data. If this is an array,
   * a for of [ { id, ... } ] is expected. If its an object and shapes.items is an array,
   * the array form will be used. Otherwise its assumed to be a { id : data } map.
   * @param {object} options the options object supplied to the layer creator
   * @param {function} cb called for each data item with ( data, id ).
   */
  iterate(shapes, options, cb) {
    if (shapes) {
      if (Array.isArray(shapes)) {
        shapes.forEach(data => {
          if (data) {
            cb(data, data.id);
          }
        });
      } else if (Array.isArray(shapes.items)) {
        shapes.items.forEach(data => {
          if (data) {
            cb(data, data.id);
          }
        });
      } else {
        Object.keys(shapes).forEach(k => {
          if (shapes[k]) {
            cb(shapes[k], k);
          }
        });
      }
    }
  }
  getShapeData(shape, id, options) {
    // eslint-disable-next-line no-console
    console.warn('getShapeData must be overridden to make shapes appear');
    return null;
  }
  getFillLayerOptions(style, layerGroup, options) {
    return FILL_STYLE;
  }
  getLabelLayerOptions() {
    return LABEL_STYLE;
  }
  getSymbolLayerOptions() {
    return SYMBOL_STYLE;
  }
  getOutlineLayerOptions() {
    return OUTLINE_STYLE;
  }
}